module.exports = __webpack_public_path__ + "img/expressionless.b20ec0c0.png";